import {
  Armchair,
  ArrowRight,
  Headphones,
  Laptop,
  Printer,
  Server,
  Wrench,
} from 'lucide-react';
import { services } from '@/mocks/donnos';

const serviceIcons = [Laptop, Printer, Headphones, Armchair, Server, Wrench];

export default function ServicesSection() {
  return (
    <section id="solucoes" className="pt-14 pb-4 md:pt-16 md:pb-5 bg-gray-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="text-center mb-7">
          <p className="text-sm md:text-base font-extrabold text-donnos-green uppercase tracking-wide mb-2">
            NOSSAS SOLUÇÕES
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-950 leading-tight">
            Tudo que sua empresa precisa{' '}
            <span className="text-donnos-green">em um só lugar</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4">
          {services.map((service, index) => {
            const Icon = serviceIcons[index] ?? Wrench;

            return (
              <a
                key={service.title}
                href="/produtos"
                className="group min-h-[238px] bg-white rounded-lg px-6 py-7 xl:px-5 shadow-[0_10px_28px_rgba(15,23,42,0.10)] border border-gray-100 flex flex-col justify-between transition-all duration-300 ease-out hover:-translate-y-2 hover:scale-[1.015] hover:border-donnos-green/40 hover:shadow-[0_18px_38px_rgba(15,23,42,0.16)] focus:outline-none focus:ring-2 focus:ring-donnos-green/60"
              >
                <div>
                  <div className="flex items-start gap-4 mb-7 xl:gap-3">
                    <Icon className="h-9 w-9 text-donnos-green shrink-0 stroke-[1.7] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3" aria-hidden="true" />
                    <h3 className="min-w-0 text-[15px] 2xl:text-[16px] font-extrabold text-gray-950 leading-snug">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-[15px] text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <span
                  aria-hidden="true"
                  className="mt-8 mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-gray-950 text-white shadow-[0_8px_18px_rgba(15,23,42,0.22)] transition-all duration-300 group-hover:bg-donnos-green group-hover:translate-x-1"
                >
                  <ArrowRight className="h-5 w-5" aria-hidden="true" />
                </span>
              </a>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href="/produtos"
            className="inline-flex items-center justify-center gap-8 bg-gray-950 hover:bg-donnos-green text-white font-bold px-10 py-3 rounded-md transition-colors min-w-[280px]"
          >
            Ver todas as soluções
            <ArrowRight className="h-5 w-5" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
